import { useContext } from 'react';
import AuthContext from '../contexts/FirebaseAuthContext';
import type { AuthContextValue } from '../contexts/FirebaseAuthContext';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
